<template>
  <div class="comment">
   <div class="search-header">
      <div class="content">
       <slot name="serachContent"></slot>
      </div>
   </div>
       <el-tabs
      :value="activeName"
      @input="handleChangeRouter"
      :class="isMounted ? 'table-tabs' : 'table-tabs table-tabs--before-mount'"
    >
      <el-tab-pane
        v-for="item in mediaFactoryTabs"
        :label="item.title"
        :name="item.name"
        :key="item.title"
      >
        <span slot="label" @click.stop="handleChangeRouter(item.name)">{{
          item.title
        }}</span>
        <slot :name="item.name"></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'mediaIndex',
      isMounted: false
    }
  },
  props: ['activeType'],
  computed: {
    mediaFactoryTabs() {
      const data = [
        {
          name: 'mediaIndex',
          title: '物料',
          show: true
        }
        // {
        //   name: 'mediaTemplate',
        //   title: '素材模版',
        //   show: true
        // }
      ]
      const list = data.filter(item => item.show)
      return list
    }
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    handleChangeRouter(val) {
      this.$router.push({ name: val })
    }
  },
  created() {
    if (this.activeType === 'mediaIndex') {
      this.activeName = 'mediaIndex'
    } else {
      this.activeName = 'mediaTemplate'
    }
  }
}
</script>
<style lang="stylus" scoped>
.comment
  position relative
  height 100%
  .search-header
    display flex
    flex-direction: row
    padding: 15px 22px
    margin-bottom 16px
    background #fff
    width 100%
    border-bottom 1px solid #dcdfe6
    box-shadow 0 1px 4px 0 rgba(0, 0, 0, 0.06)
    align-items center
    justify-content space-between
    box-sizing border-box
    .content
      margin-right 10px
      .el-form-item
        margin-bottom 0px
.table-tabs
  margin 16px
  // margin 0 24px 16px 24px
  background #fff !important
  border none
  >>>.el-tabs__nav-wrap:after
      content none
  >>>.el-tabs__item
      padding 0
      color rgba(0, 0, 0, 0.65)
      height 53px
      width 128px
      text-align center
      padding-right 32px
  >>>.el-tabs__item.is-active, >>>.el-tabs__item :hover
      color #FF8B00
  >>>.el-tabs__item span
      font-size 16px
      display block
      width 96px
      height 53px
      line-height 53px
  >>>.el-tabs__header
      margin 0
      border-bottom 1px solid #F0F2F5
      padding 0px 16px 0px
  >>>.el-tabs__active-bar
      width 96px !important
  >>>.el-tabs__content
      padding 0px 32px
  >>>.el-tabs__header
      margin 0
>>>.el-tabs__item:focus.is-active.is-focus:not(:active)
    box-shadow none
.table-tabs .table-tabs--before-mount
  >>>.el-tabs__active-bar
    transition none
>>>.el-tabs__active-bar
    transition none
</style>
